import { Card, CardBody, Input } from '@heroui/react';
import _ from 'lodash';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function NumInput({ answerHistory, sendAnswer, options }) {
  const { t } = useTranslation('survey');
  const [error, setError] = useState('');

  const validateNumber = useCallback(
    (value) => {
      setError('');

      const { min, max } = options;
      const minNumber = _.toNumber(min);
      const maxNumber = _.toNumber(max);

      if (_.isNaN(_.toNumber(value))) {
        setError(t('numinput.error.invalid'));
        return false;
      }

      if (!_.isNil(minNumber) && value < minNumber) {
        setError(t('numinput.error.min', { value: minNumber }));
        return false;
      }
      if (maxNumber && value > maxNumber) {
        setError(t('numinput.error.max', { value: maxNumber }));
        return false;
      }

      return true;
    },
    [options]
  );

  const handleInput = (e) => {
    const answer = e.target.value;
    const valid = validateNumber(answer);

    if (!valid) {
      sendAnswer(null);
    } else {
      setError('');
      sendAnswer(answer);
    }
  };

  return (
    <>
      <Card className="max-w-md">
        <CardBody>
          <Input
            color="primary"
            defaultValue={answerHistory}
            endContent={
              <div className="flex items-center">
                <span>{options.unit}</span>
              </div>
            }
            errorMessage={error}
            isInvalid={!_.isEmpty(error)}
            onChange={(e) => handleInput(e)}
            size="lg"
            type="number"
            variant="underlined"
          />
        </CardBody>
      </Card>
    </>
  );
}
